import { render, staticRenderFns } from "./Geofencing.vue?vue&type=template&id=3b156fdd&scoped=true&"
import script from "./Geofencing.vue?vue&type=script&lang=js&"
export * from "./Geofencing.vue?vue&type=script&lang=js&"
import style0 from "./Geofencing.vue?vue&type=style&index=0&id=3b156fdd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b156fdd",
  null
  
)

export default component.exports